export default "__VITE_ASSET__fdaa0498__"